export enum RolesEnum {
  MANAGER = 'manager',
  AGENT = 'agent',
  PROMOTION_MANAGER = 'promotion-manager',
  // todo: исправить на jun-manager (бек и фронт)
  JUN_MANAGER = 'jun_manager',
  ACCOUNTANT = 'accountant',
  CUSTOMER = 'customer',
  ADMIN = 'admin',
  SUPER_ADMIN = 'super_admin',
  QA_TESTER = 'qa_tester',
}
